module.exports = __webpack_public_path__ + "c378483e8176aeec5d2e9a37cbb4bfbc.pdf";